import React from 'react'
import SecModule from './SecModule';
import moduleData from './Data/Data';

const MainSecond = React.memo(() => {
  return (
    <>
      <div className="relative bg-[#f1f5f8] flex flex-col items-center justify-center">
        <div className="w-full max-w-7xl px-2 sm:px-9">
          <div className="text-center text-4xl font-semibold py-10">
            User Interface of <span className="text-[#519980]">GST Return</span>{" "}
            & Billing Software
          </div>
          <SecModule dataStore={moduleData} />
          <div className="w-full flex justify-end mt-2 max-w-7xl mb-9">
            <a
              href="https://www.easyofficesoftware.com/easygst"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-end"
            >
              <p className="mb-0 mr-1 text-black text-lg font-bold">
                Learn More
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-right mt-1"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
});

export default MainSecond;